import { HiArrowRight } from "react-icons/hi";
import Container from "../../components/Container";
import CustomInput from "../../components/CustomInput";
import influencerImage from "../../assets/images/coach.jpg";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import ProceedButton from "../../components/ProceedButton";

const Payment = () => {
  return (
    <section className="bg-white">
      <Container>
        <div className="payment-steps px-4">
          <div className="flex flex-wrap">
            <div className="pb-4 mb-4 last:border-b-0 xs:w-full md:w-8/12">
              <div className="single-step xs:w-full md:w-8/12">
                <div className="title text-lg font-medium text-[#e66553] flex">
                  <span className="pr-1">1.</span>
                  <h2>Payment</h2>
                </div>
                <div className="payment-form">
                  <form action="">
                    <div className="flex flex-wrap">
                      <CustomInput
                        label={"Card Number"}
                        name={"card-number"}
                        placeholder="Enter your card number!"
                        className={"w-full pt-4 pr-4 first:pr-0 last:pr-0"}
                      />
                      <CustomInput
                        label={"Expiry Date"}
                        name={"expiry-date"}
                        placeholder="MM / YY"
                        type="date"
                        className={
                          "xs:w-full sm:w-1/2 xs:pr-0 pt-4 sm:pr-4 first:pr-0 last:pr-0"
                        }
                      />
                      <CustomInput
                        label={"CVV"}
                        name={"cvv"}
                        placeholder="Enter your CVV"
                        className={
                          "xs:w-full sm:w-1/2 pt-4 pr-4 first:pr-0 last:pr-0"
                        }
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="border-b pb-4 last:border-b-0 xs:w-full md:w-4/12">
              <div className="single-step">
                <div className="title text-lg font-medium text-[#e66553] flex">
                  <span className="pr-1">2.</span>
                  <h2>Review your Order</h2>
                </div>
                <div className="order-summary pt-4">
                  <div className="border rounded-md">
                    <div className="duet uppercase text-sm border-b last:border-b-0 p-4">
                      <div className="single flex justify-between">
                        <span>Duet Private (2 Max)</span>
                        <span>$1100.0</span>
                      </div>
                      <div className="single flex justify-between">
                        <span>Tax</span>
                        <span>$1100.0</span>
                      </div>
                    </div>
                    <div className="total uppercase text-sm border-b last:border-b-0 p-4">
                      <div className="single flex justify-between">
                        <span>Total</span>
                        <span>$1100.0</span>
                      </div>
                    </div>
                    <div className="total bg-[#f8f8f8] text-sm border-b last:border-b-0 p-4">
                      <div className="single justify-between p-4">
                        <h5 className="mb-1">Initial Assessment</h5>
                        <p className="text-[#8b8b8b]">
                          15 minutes intial consultation, Initial dietary
                          analysis
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="influencer border-b">
                  <div className="py-6 flex items-center">
                    <div className="image w-4/12 pr-4 overflow-hidden">
                      <img
                        src={influencerImage}
                        alt=""
                        className="w-full rounded-full"
                      />
                    </div>
                    <div className="info flex-auto px-4">
                      <div className="name text-base font-semibold">
                        <span>Ebru Bekiroğlu</span>
                      </div>
                      <div className="location text-sm text-[#828282]">
                        <span>Istanbul, Turkey</span>
                      </div>
                      <div className="languages py-2 flex">
                        <span className="bg-[#ffd2c9] text-[11px] text-[#803324] rounded font-semibold py-1 px-2 mr-1">
                          Turkish
                        </span>
                        <span className="bg-[#ffd2c9] text-[11px] text-[#803324] rounded font-semibold py-1 px-2 mr-1">
                          Turkish
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="proceed-action py-4 text-white">
                  <ProceedButton />
                </div>
                <div className="help text-sm text-[#e66553] py-4">
                  <Link to="">Need a help?</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Payment;
